import type { ReportDetail } from '../../types';
export function ScoreCard({ report }: { report: ReportDetail }) {
  const successful = report.articles.filter((item) => item.status === 'success');
  const label =
    report.status === 'partial_failed'
      ? '部分完成，不计算平均分'
      : report.mode === 'compare'
        ? '双篇平均分'
        : successful[0]?.score_grade || '综合评分';
  return (
    <div className={`score-large ${report.overall_score == null ? 'unavailable' : ''}`}>
      <span>综合评分</span>
      <strong>{report.overall_score ?? '—'}</strong>
      <span>{label}</span>
    </div>
  );
}
